import { EventEmitter } from '@/utils/emitter';
/**
 * qt bridge提供使用
 */
const bridgeEventEmitter = new EventEmitter();
/**
 * 本地web提供的bridge桥使用
 */
const webEventEmitter: EventEmitter<any> = new EventEmitter<any>();

export { bridgeEventEmitter, webEventEmitter };
